var _defs, _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoIrrigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "NO_IRRIGATION",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #NO_IRRIGATION .cls-1 {\n        fill: #ff7600;\n      }\n\n      #NO_IRRIGATION .cls-2 {\n        fill: #f5f5f5;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_115",
    "data-name": "Pfad 115",
    className: "cls-1",
    d: "M16,2A14,14,0,1,1,2,16,14.041,14.041,0,0,1,16,2m0-2A16,16,0,1,0,32,16,15.983,15.983,0,0,0,16,0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_30",
    "data-name": "Rechteck 30",
    className: "cls-1",
    width: 30.2,
    height: 2,
    transform: "translate(4.605 25.933) rotate(-45)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_48",
    "data-name": "Gruppe 48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_116",
    "data-name": "Pfad 116",
    className: "cls-1",
    d: "M19.3,11.2,10,20.5a5.244,5.244,0,0,0,1,1.8L20.3,13A16.179,16.179,0,0,0,19.3,11.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_117",
    "data-name": "Pfad 117",
    className: "cls-2",
    d: "M18.4,16.4h.3A1.6,1.6,0,1,1,17.1,18v-.4l-5.5,5.5a6.3,6.3,0,0,0,10.6-4.7A12.143,12.143,0,0,0,20.8,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_118",
    "data-name": "Pfad 118",
    className: "cls-2",
    d: "M18.8,10.3C17.3,7.9,16,5.9,16,5.9s-6.3,9-6.3,12.5a3.4,3.4,0,0,0,.1,1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoIrrigation);
export default __webpack_public_path__ + "static/media/no-irrigation.35da14b9ca9f3d66aae8d47dec144d09.svg";
export { ForwardRef as ReactComponent };